import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { ROUTES } from '@/constants/routes'

import CardComponent from '@/components/CardComponent'
import CardList from '@/components/CardList/index'
import Section from '@/components/Section/index'

import TransactionHistoryItem from '../TransactionHistoryItem/index'

/**
 * Maps API response items to CardList format
 * @param {Array} apiItems - Items from API response
 * @returns {Array} Mapped items for CardList
 */
const mapApiItemsToCardList = apiItems => {
  if (!apiItems || !Array.isArray(apiItems)) {
    return []
  }

  return apiItems.map((item, index) => ({
    id: item.id || `transaction-${index}`,
    title: item.title || '',
    subtitle: item.subtitle || '',
    description: item.description || '',
    meta: item.meta || {},
    assets: item.assets || {},
    route: item.actions?.default?.url || null,
    showArrow: !!item.assets?.trailingIcon || false,
    listIndex: index
  }))
}

const TransactionHistoryList = ({ data }) => {
  const navigate = useNavigate()

  const mappedItems = useMemo(() => {
    return mapApiItemsToCardList(data?.components?.items)
  }, [data?.components?.items])

  const handleItemClick = item => {
    const meta = item.meta || {}
    const params = new URLSearchParams()

    params.set('txnIndex', String(item.listIndex ?? 0))

    if (meta.loan_id != null && String(meta.loan_id).trim() !== '') {
      params.set('loanId', String(meta.loan_id))
    }

    if (params.toString()) {
      navigate(`${ROUTES.HISTORY}?${params.toString()}`)
    }
  }

  const renderItem = item => {
    return <TransactionHistoryItem item={item} onClick={handleItemClick} />
  }

  const listEmptyState = (
    <CardComponent>
      <div className='ew-d-flex ew-flex-column ew-justify-content-center ew-align-items-center ew-py-16'>
        <span className='ew-typography-small ew-fw-regular ew-color-secondary ew-text-center'>
          {data?.empty_message || 'No transactions yet'}
        </span>
      </div>
    </CardComponent>
  )

  return (
    <Section title={data?.title}>
      <CardList emptyState={listEmptyState} items={mappedItems} renderItem={renderItem} />
    </Section>
  )
}

export default TransactionHistoryList
